import _extends from "@babel/runtime-corejs3/helpers/extends";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof _Object$getOwnPropertySymbols === "function") for (var i = 0, p = _Object$getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import React from 'react';
import classNames from 'classnames';
function isString(str) {
  return typeof str === 'string';
}
var Step = function Step(props) {
  var _context;
  var _props$stepNumber = props.stepNumber,
    stepNumber = _props$stepNumber === void 0 ? 1 : _props$stepNumber,
    _props$stepIndex = props.stepIndex,
    stepIndex = _props$stepIndex === void 0 ? 0 : _props$stepIndex,
    prefixCls = props.prefixCls,
    status = props.status,
    className = props.className,
    _props$title = props.title,
    title = _props$title === void 0 ? '' : _props$title,
    description = props.description,
    icon = props.icon,
    icons = props.icons,
    _props$current = props.current,
    current = _props$current === void 0 ? 0 : _props$current,
    onClick = props.onClick,
    style = props.style,
    onStepClick = props.onStepClick,
    others = __rest(props, ["stepNumber", "stepIndex", "prefixCls", "status", "className", "title", "description", "icon", "icons", "current", "onClick", "style", "onStepClick"]);
  var handleClick = function handleClick(e) {
    onClick && onClick(e);
    onStepClick && onStepClick(stepIndex || 0);
  };
  var stepClassName = classNames("".concat(prefixCls, "-item"), _concatInstanceProperty(_context = "".concat(prefixCls, "-item-")).call(_context, status), className, _defineProperty({}, "".concat(prefixCls, "-item-clickable"), onClick || onStepClick));
  var renderIconNode = function renderIconNode() {
    var iconNode;
    if (icon && !isString(icon)) {
      iconNode = icon;
    } else if (icons && icons.finish && !isString(icons.finish) && status === 'finish') {
      iconNode = icons.finish;
    } else if (icons && icons.wait && !isString(icons.wait) && status === 'wait') {
      iconNode = icons.wait;
    } else if (icons && icons.error && !isString(icons.error) && status === 'error') {
      iconNode = icons.error;
    } else if (icons && icons.process && !isString(icons.process) && status === 'process') {
      iconNode = icons.process;
    } else {
      iconNode = stepNumber;
    }
    return /*#__PURE__*/React.createElement("span", {
      className: "".concat(prefixCls, "-icon")
    }, iconNode);
  };
  var iconContainerClassName = classNames("".concat(prefixCls, "-item-iconContainer"), _defineProperty({}, "".concat(prefixCls, "-item-iconContainer-finish"), current > stepIndex));
  return /*#__PURE__*/React.createElement("div", _extends({}, others, {
    className: stepClassName,
    style: style,
    onClick: handleClick
  }), /*#__PURE__*/React.createElement("div", {
    onClick: onClick,
    className: "".concat(prefixCls, "-item-container")
  }, /*#__PURE__*/React.createElement("div", {
    className: iconContainerClassName
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "-item-iconContainer-icon")
  }, renderIconNode())), /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "-item-content")
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "-item-title"),
    title: isString(title) ? title : ''
  }, title), description && /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "-item-description"),
    title: isString(description) ? description : ''
  }, description))));
};
Step.displayName = 'Step';
export default Step;